import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const MapActions = createActionGroup({
  source: 'MAP',
  events: {
    toggleCvButton: emptyProps(),
    toggleMarkersMinimizedButton: emptyProps(),
    updateStreetViewActive: props<{ streetViewActive: boolean }>(),
    updateStreetViewClosedByUser: props<{ streetViewClosedByUser: boolean }>(),
    updateShowValidationHistory: props<{ showValidationHistory: boolean }>(),
  }
})
